export default __webpack_public_path__ + "static/media/boat_light.566a6ae8.png";